module.exports = __webpack_public_path__ + "static/img/haidilao.1e72fe5.png";


//////////////////
// WEBPACK FOOTER
// ./static/picture/haidilao.png
// module id = uvGV
// module chunks = 65